import { Box, Divider, Snackbar } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import React from "react";
import { useTranslation } from "react-i18next";

import useTableHeight from "../../utils/use-table-height";
import AppliedFilters from "../filters/applied-filters";
import { APPLIED_FILTERS_HEIGHT } from "../filters/constants";
import useJobsMatrixColumns from "./controller/use-jobs-matrix-columns";
import { useJobsMatrixController } from "./controller/use-jobs-matrix-controller";
import WorkerJobDetailsDialog from "./ui/dialog/worker-job-details-dialog";
import JobsMatrixHeader from "./ui/jobs-matrix-header";
import JobsMatrixTable from "./ui/jobs-matrix-table";

const JobsMatrix: React.FC = () => {
    const { t } = useTranslation();
    const {
        data,
        allJobs,
        jobStatuses,
        loading,
        searchText,
        updateWorkerJobStatusState,
        updateWorkerJobStatusError,
        handleJobStatusChange,
        handleSearchChange,
        handleResetUpdateStatus,
        filters,
        setFilters,
        appliedFilters,
        isFilterOpen,
        setIsFilterOpen,
        filterStatus,
        filterAccordionHeight,
        defaultAppliedFilters,
        isJobDetailsDialogOpen,
    } = useJobsMatrixController();

    const {
        columns,
        pickerColumns,
        handleSelectColumns,
        disabledColumns,
    } = useJobsMatrixColumns(searchText);

    const { height: containerHeight, boxRef } = useTableHeight();

    return (
      <Box>
        <JobsMatrixHeader
          searchText={searchText}
          onSearchChange={handleSearchChange}
          jobStatuses={jobStatuses}
          pickerColumns={pickerColumns}
          handleSelectColumns={handleSelectColumns}
          disabledColumns={disabledColumns}
          isFilterOpen={isFilterOpen}
          setIsFilterOpen={setIsFilterOpen}
          filterStatus={filterStatus}
        />

        <Box sx={{ flexGrow: 1, overflow: "hidden", width: "100%" }}>
          <Box sx={{ width: "100%", height: "100%" }}>
            <Divider />
            <AppliedFilters />
            <Box ref={boxRef}>
              <JobsMatrixTable
                data={data}
                allJobs={allJobs}
                jobStatuses={jobStatuses}
                loading={loading}
                searchText={searchText}
                workerColumns={columns}
                handleJobStatusChange={handleJobStatusChange}
                height={containerHeight}
                isFilterOpen={false}
              />
            </Box>
          </Box>
        </Box>

        {isJobDetailsDialogOpen && <WorkerJobDetailsDialog />}

        {updateWorkerJobStatusState === "fulfilled" && (
          <Snackbar
            open={updateWorkerJobStatusState === "fulfilled"}
            autoHideDuration={3000}
            onClose={handleResetUpdateStatus}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert elevation={6} variant="filled" severity="success">
              {t("jobs-matrix_job-status-updated")}
            </MuiAlert>
          </Snackbar>
        )}
        {updateWorkerJobStatusState === "rejected" && (
          <Snackbar
            open={updateWorkerJobStatusState === "rejected"}
            autoHideDuration={3000}
            onClose={handleResetUpdateStatus}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <MuiAlert elevation={6} variant="filled" severity="error">
              {updateWorkerJobStatusError || t("jobs-matrix_failed-update-job-status")}
            </MuiAlert>
          </Snackbar>
        )}
      </Box>
    );
};

export default JobsMatrix;
